import { Card } from "../general/card";
import { Metric } from "../general/custom";
import { Box } from "@mui/material";
import Loader from "../general/loader";
import { formatEnergy } from "../../scripts/utils";

export default function BatteryInfo({ data, isFetching }) {
  const totalCharged = data?.total_charged ? Number(data.total_charged.toFixed(2)) : null;
  const totalDischarged = data?.total_discharged ? Number(data.total_discharged.toFixed(2)) : null;
  const cycles = data?.total_cycles ? Number(data.total_cycles.toFixed(2)) : null;

  return (
    <Card display="flex" flexDirection="column" justifyContent="center" alignItems="center" title="Battery statistics">
      {isFetching ? (
        <Loader />
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            rowGap: 1,
            columnGap: { xs: 0, sm: 1 },
          }}
        >
          <Metric name="Total Charged" value={formatEnergy(totalCharged)} width={{ xs: 120, sm: 170, md: 200 }} />
          <Metric name="Total Discharged" value={formatEnergy(totalDischarged)} width={{ xs: 120, sm: 170, md: 200 }} />
          <Metric
            name="Cycles per day"
            value={cycles !== null ? cycles : "-"}
            width={{ xs: 120, sm: 170, md: 200 }}
            info="A cycle is a full charge and discharge of the battery. Going from 0% to 100% and back to 0% counts as 1 cycle."
          />
        </Box>
      )}
    </Card>
  );
}
